const DISCOVERY_MENU_ITEMS = {
    main: 'discovery',
    category1: 'discovery_category1',
    category2: 'discovery_category2',
    category3: 'discovery_category3',
    category4: 'discovery_category4'
};

export {DISCOVERY_MENU_ITEMS};
